import { LayerGroup } from 'react-leaflet';
import { ReactElement } from 'react';
import { isPositionModelWithLatLng } from '@cas/types/assets';
import { getRotationProps, RotationModel } from '../../markers/utils';
import { SafetyAlertModel } from '@casops/store/apis/personnelSafetyApi';
import AssetPositionMarker from '../../markers/asset-position-marker/AssetPositionMarker';
import { IconColor } from '../../markers/icons';
import {
  SafetyEventTooltip,
  SafetyEventTooltipProps,
} from '../safety-event-tooltip/SafetyEventTooltip';

interface SafetyEventLayerProps {
  alert: Pick<SafetyAlertModel, 'posA' | 'typ' | 'did' | 'ts'>;
  tooltipPane?: SafetyEventTooltipProps['tooltipPane'];
}

/**
 * Show an asset marker if the safety event has a position.
 */
export const SafetyEventLayer = ({
  alert: { posA, typ, did, ts },
  tooltipPane,
}: SafetyEventLayerProps): ReactElement => {
  const rotationProps: RotationModel | undefined = isPositionModelWithLatLng(posA)
    ? getRotationProps(posA)
    : undefined;

  return (
    <LayerGroup>
      {rotationProps && (
        <AssetPositionMarker {...rotationProps} color={IconColor.Red}>
          <SafetyEventTooltip ts={ts} did={did} eventType={typ} tooltipPane={tooltipPane} />
        </AssetPositionMarker>
      )}
    </LayerGroup>
  );
};
